import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '../../../../../../constants';
import './style.less';

const S4 = ({ os }) => (
  <React.Fragment>
    <div className="highlight1" />
    <div className="highlight2" />
    <div className="highlight3" />
    <div className="bubble1" />
    <div className="bubble2" />
    {os === DEVICE.PAD ? <div className="bubble3" /> : ''}
    <div className="octopus1" />
    <div className="octopus2" />
    <div className="wire1" />
    <div className="wire2" />
    <div className="wire3" />
    <div className="wire4" />
    <div className="acuatic-plant" />
    <div className="shell" />
    <div className="seaweed" />
    <div className="light" />
    <div className="coral" />
    <div className="fish" />
    {os === DEVICE.PC ? (
      <React.Fragment>
        <div className="fish1" />
        <div className="fish2" />
        <div className="rock" />
      </React.Fragment>
    ) : ''}
    <div className="shrimp" />
  </React.Fragment>
);

S4.propTypes = {
  os: PropTypes.string,
};
export default S4;
